import { render } from "./backcoverWidget.vue?vue&type=template&id=4388ddbc&scoped=true"
import script from "./backcoverWidget.vue?vue&type=script&lang=js"
export * from "./backcoverWidget.vue?vue&type=script&lang=js"

import "./backcoverWidget.vue?vue&type=style&index=0&id=4388ddbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4388ddbc"]])

export default __exports__